import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Heading } from 'ui/components/1-atoms/Heading/Heading';
import styles from './Tabs.module.scss';

export interface TabsProps {
	selectedId?: string;
	tabs: {
		title: string;
		id: string;
		content: React.ReactNode;
	}[];
}

export const Tabs = ({ tabs, selectedId }: TabsProps) => {
	const [selectedTabId, setSelectedTabId] = useState<string | undefined>(selectedId);

	useEffect(() => {
		const getHashId = () => window.location.hash.replace('#', '');

		const isValidTabId = (id?: string) => tabs.some((tab) => tab.id === id);

		const init = () => {
			const hashId = getHashId();
			const validHashId = isValidTabId(hashId) ? hashId : undefined;
			const validSelectedId = isValidTabId(selectedId) ? selectedId : undefined;
			const fallbackId = tabs[0]?.id;

			setSelectedTabId(validHashId || validSelectedId || fallbackId);
		};

		init();

		const handleHashChange = () => {
			const hashId = getHashId();
			if (isValidTabId(hashId)) {
				setSelectedTabId(hashId);
			}
		};

		window.addEventListener('hashchange', handleHashChange);
		return () => window.removeEventListener('hashchange', handleHashChange);
	}, [selectedId, tabs]);

	return (
		<div className={styles.Tabs}>
			<nav className={styles.Tabs_navigation}>
				<ul className={styles.Tabs_navigationList}>
					{tabs.map((tab) => (
						<li className={styles.Tabs_listItem} key={tab.id}>
							<a className={styles.Tabs_listButton} href={`#${tab.id}`} aria-current={selectedTabId === tab.id}>
								{tab.title}
							</a>
						</li>
					))}
				</ul>
			</nav>

			<div className={styles.Tabs_contentContainer}>
				{tabs.map((tab) => (
					<div key={tab.id} className={styles.Tabs_itemContent} hidden={selectedTabId !== tab.id}>
						{tab.content}
					</div>
				))}
			</div>
		</div>
	);
};
